define(['zepto', 'warmupUtils'], function ($, warmupUtils) {
    'use strict';

    const {tpaWarmup} = warmupUtils;

    function reportIframeStartLoading($iframe, siteData) {
        const compId = $iframe.attr('name');
        if (tpaWarmup.isTpaSupportedInWarmup(siteData, compId)) {
            tpaWarmup.reportWarmupPerformanceBiEvent(tpaWarmup.events.APP_IFRAME_START_LOADING, siteData, compId);
        }
    }

    return {
        setIframesSrc(siteData) {
            $('#SITE_CONTAINER iframe[data-src]').each(function () {
                const $this = $(this);
                const dataSrc = $this.data('src');
                if (dataSrc) {
                    const src = $this.attr('src');
                    if (src !== dataSrc) {
                        $this.attr('src', dataSrc);
                        reportIframeStartLoading($this, siteData);
                    }
                    $this.removeAttr('data-src');
                }
            });
        },
        reportPresetIframes(siteData) {
            $('#SITE_CONTAINER iframe[src]').each(function () {
                const $this = $(this);
                const src = $this.attr('src');
                if (src) {
                    const dataSrc = $this.data('src');
                    if (!dataSrc) {
                        reportIframeStartLoading($this, siteData);
                    }
                }
            });
        }
    };
});
